import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js";
import { subscribe_webpush_subscriptions_path } from "../routes";

const vapidPublicKey = document.querySelector(
  'meta[name="vapid-public-key"]',
).content;

// Connects to data-controller="webpush"
export default class extends Controller {
  async connect() {
    return

    switch (window.Notification?.permission) {
      case null:
          return // not supported
      case undefined:
          return // not supported
      case "granted":
          await this.saveSubscription()
          return
      case "denied":
          return // do nothing?
      default:
          this.promptForNotifications()
    }
  }

  promptForNotifications() {
    window.Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        this.setup()
      }
    })
  }

  async setup() {
    if (window.Notification?.permission !== "granted") return
    if (!navigator.serviceWorker) return

    await navigator.serviceWorker.register('/service-worker.js')

    const registration = await navigator.serviceWorker.ready
    await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidPublicKey
    })

    await this.saveSubscription()
  }

  async saveSubscription() {
    if (window.Notification?.permission !== "granted") return
    if (!navigator.serviceWorker) return

    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()
    if (!subscription) return

    await post(subscribe_webpush_subscriptions_path(), {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(subscription)
    })

  }
}
